import axios from "axios";

const CENTER_API_URL = process.env.REACT_APP_CENTERSERVICE_URL;

export const ASK_DEVICE_TO_SERVER = `${CENTER_API_URL}/api/v1/AiAssistant/AskDeviceToServer`;
export const ASK_SERVER_TO_DEVICE = `${CENTER_API_URL}/api/v1/AiAssistant/AskServerToDevice`;


export async function AskDeviceToServer(message) {
    try {
        const response = await axios.post(ASK_DEVICE_TO_SERVER, {
            message
        });

        return response.data.answer;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function AskServerToDevice(message) {
    try {
        const response = await axios.post(ASK_SERVER_TO_DEVICE, {
            message
        });

        return response.data.answer;
    } catch (error) {
        console.error(error);
        throw error;
    }
}
